(function () {
  'use strict';

  var LS = {
    state: 'vq:state',
    products: 'vq:products',
    collections: 'vq:collections',
    time: 'vq:time',
    celebrated: 'vq:celebrated'
  };

  var REWARD_CODE = 'VILLAIN5';

  var ACHIEVEMENTS = [
    { id: 'explorer',      name: 'Explorer',      desc: 'Visit the brand story page',     icon: '🗺️' },
    { id: 'windowShopper', name: 'Window Shopper', desc: 'View 5 different products',      icon: '👁' },
    { id: 'hangingOut',    name: 'Hanging Out',    desc: 'Spend 5 minutes on the site',    icon: '⏳' },
    { id: 'firstPick',     name: 'First Pick',     desc: 'Add an item to your cart',       icon: '🛒' },
    { id: 'styleCurator',  name: 'Style Curator',  desc: 'Cart items from 2+ collections', icon: '⚡' }
  ];

  // ── State ─────────────────────────────────────────────────────────────────
  function getState() {
    try { return JSON.parse(localStorage.getItem(LS.state) || '{}'); } catch (e) { return {}; }
  }

  function setState(state) {
    try { localStorage.setItem(LS.state, JSON.stringify(state)); } catch (e) {}
  }

  function isUnlocked(id) {
    return !!getState()[id];
  }

  function unlock(id) {
    if (isUnlocked(id)) return;
    var state = getState();
    state[id] = Date.now();
    setState(state);
    var a = ACHIEVEMENTS.filter(function (a) { return a.id === id; })[0];
    if (a) showToast(a);
    pulseButton();
    spawnConfetti();
    refreshUI();
    // Check for all-complete after a short delay so the toast shows first
    var total = ACHIEVEMENTS.filter(function (a) { return !!state[a.id]; }).length;
    if (total === ACHIEVEMENTS.length) {
      setTimeout(showRewardModal, 2000);
    }
  }

  // ── Toast ─────────────────────────────────────────────────────────────────
  function showToast(achievement) {
    var prev = document.getElementById('vq-toast');
    if (prev) prev.remove();

    var toast = document.createElement('div');
    toast.id = 'vq-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<div class="vq-toast__icon">' + achievement.icon + '</div>' +
      '<div class="vq-toast__body">' +
        '<div class="vq-toast__eyebrow">Achievement Unlocked!</div>' +
        '<div class="vq-toast__name">' + achievement.name + '</div>' +
      '</div>';
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.classList.add('vq-toast--show'); });
    });

    setTimeout(function () {
      toast.classList.remove('vq-toast--show');
      toast.addEventListener('transitionend', function () { toast.remove(); }, { once: true });
    }, 5500);
  }

  // ── Reward Modal ──────────────────────────────────────────────────────────
  function showRewardModal() {
    try { if (localStorage.getItem(LS.celebrated)) return; } catch (e) {}

    var overlay = document.createElement('div');
    overlay.id = 'vq-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Villain Quests Complete');
    overlay.innerHTML =
      '<div class="vq-modal" id="vq-modal">' +
        '<button class="vq-modal__close" id="vq-modal-close" aria-label="Close">✕</button>' +
        '<div class="vq-modal__skull">💀</div>' +
        '<h2 class="vq-modal__heading">You\'ve Gone Full Villain</h2>' +
        '<p class="vq-modal__sub">All 5 quests conquered. Your reward awaits.</p>' +
        '<div class="vq-modal__code-block">' +
          '<span class="vq-modal__code-label">Your Discount Code</span>' +
          '<div class="vq-modal__code" id="vq-modal-code">' + REWARD_CODE + '</div>' +
          '<button class="vq-modal__copy" id="vq-modal-copy">Copy Code</button>' +
        '</div>' +
        '<p class="vq-modal__note">Use at checkout for your exclusive reward.</p>' +
      '</div>';
    document.body.appendChild(overlay);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { overlay.classList.add('vq-modal-overlay--show'); });
    });

    function close() {
      overlay.classList.remove('vq-modal-overlay--show');
      overlay.addEventListener('transitionend', function () { overlay.remove(); }, { once: true });
    }

    document.getElementById('vq-modal-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); }, { once: true });

    document.getElementById('vq-modal-copy').addEventListener('click', function () {
      navigator.clipboard.writeText(REWARD_CODE).then(function () {
        var btn = document.getElementById('vq-modal-copy');
        if (btn) { btn.textContent = 'Copied!'; btn.classList.add('vq-modal__copy--copied'); }
      }).catch(function () {
        // Fallback for older browsers
        var el = document.getElementById('vq-modal-code');
        var range = document.createRange();
        range.selectNode(el);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand('copy');
        var btn = document.getElementById('vq-modal-copy');
        if (btn) { btn.textContent = 'Copied!'; btn.classList.add('vq-modal__copy--copied'); }
      });
    });

    try { localStorage.setItem(LS.celebrated, '1'); } catch (e) {}
  }

  // ── Button confetti + pulse ───────────────────────────────────────────────
  function pulseButton() {
    var trigger = document.getElementById('vq-trigger');
    if (!trigger) return;
    trigger.classList.remove('vq-trigger--pop');
    void trigger.offsetWidth; // force reflow to restart animation
    trigger.classList.add('vq-trigger--pop');
    trigger.addEventListener('animationend', function () {
      trigger.classList.remove('vq-trigger--pop');
    }, { once: true });
  }

  function spawnConfetti() {
    var trigger = document.getElementById('vq-trigger');
    if (!trigger) return;
    var rect = trigger.getBoundingClientRect();
    var originX = (rect.left + rect.width / 2) / window.innerWidth;
    var originY = (rect.top + rect.height / 2) / window.innerHeight;

    function fire(confetti) {
      confetti({
        particleCount: 90,
        spread: 80,
        origin: { x: originX, y: originY },
        colors: ['#ff3b3b', '#ff8c00', '#ffd700', '#ffffff', '#ff6b6b', '#ffcc44'],
        startVelocity: 28,
        ticks: 70,
        scalar: 0.95,
        zIndex: 10000
      });
    }

    if (window.confetti) {
      fire(window.confetti);
    } else {
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js';
      s.onload = function () { fire(window.confetti); };
      document.head.appendChild(s);
    }
  }

  // ── Floating Widget ───────────────────────────────────────────────────────
  function buildWidget() {
    if (document.getElementById('vq-widget')) { refreshUI(); return; }

    var widget = document.createElement('div');
    widget.id = 'vq-widget';
    widget.innerHTML =
      '<button class="vq-trigger" id="vq-trigger" aria-label="Villain Quests" aria-expanded="false">' +
        '<span class="vq-trigger__icon">⚔️</span>' +
        '<span class="vq-trigger__badge" id="vq-badge">0</span>' +
      '</button>' +
      '<div class="vq-panel" id="vq-panel" aria-hidden="true">' +
        '<div class="vq-panel__header">' +
          '<span class="vq-panel__title">Villain Quests</span>' +
          '<button class="vq-panel__close" id="vq-close" aria-label="Close">✕</button>' +
        '</div>' +
        '<p class="vq-panel__intro">Every syndicate starts with an initiation. These aren\'t tasks — they\'re trials. Complete them, and you\'re no longer a customer. You\'re one of us. But this is Tier 1.</p>' +
        '<div class="vq-panel__bar-track"><div class="vq-panel__bar-fill" id="vq-fill"></div></div>' +
        '<ul class="vq-panel__list" id="vq-list"></ul>' +
      '</div>';
    document.body.appendChild(widget);

    document.getElementById('vq-trigger').addEventListener('click', function () {
      var panel = document.getElementById('vq-panel');
      var open = panel.getAttribute('aria-hidden') === 'false';
      panel.setAttribute('aria-hidden', open ? 'true' : 'false');
      panel.classList.toggle('vq-panel--open', !open);
      this.setAttribute('aria-expanded', String(!open));
    });

    document.getElementById('vq-close').addEventListener('click', function () {
      var panel = document.getElementById('vq-panel');
      panel.setAttribute('aria-hidden', 'true');
      panel.classList.remove('vq-panel--open');
      document.getElementById('vq-trigger').setAttribute('aria-expanded', 'false');
    });

    refreshUI();
  }

  function openPanel() {
    buildWidget();
    var panel = document.getElementById('vq-panel');
    var trigger = document.getElementById('vq-trigger');
    if (!panel || !trigger) return;
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('vq-panel--open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  // ── Achievements nav link → open widget panel instead of navigating ───────
  function navLinkLabel(a) {
    var ariaLabel = a.getAttribute('aria-label');
    if (ariaLabel) return ariaLabel.trim();
    var textSpan = a.querySelector('.btn-text:not(.btn-duplicate)');
    if (textSpan) return (textSpan.textContent || '').trim();
    return (a.textContent || '').trim();
  }

  function initAchievementsNavLink() {
    var ctx = window.vqContext || {};
    var homePath;
    try { homePath = new URL(ctx.homeUrl || '/', window.location.origin).pathname; } catch (e) { homePath = '/'; }
    homePath = homePath.replace(/\/$/, '') || '/';

    document.querySelectorAll('a[href]').forEach(function (a) {
      if (a.dataset.vqBound) return;
      var text = navLinkLabel(a).toLowerCase();
      if (text !== 'achievements') return;

      var linkPath;
      try { linkPath = new URL(a.href, window.location.origin).pathname; } catch (e) { return; }
      linkPath = linkPath.replace(/\/$/, '') || '/';
      if (linkPath !== homePath) return;

      a.dataset.vqBound = 'true';
      a.addEventListener('click', function (e) {
        e.preventDefault();

        var drawer = document.getElementById('MenuDrawer');
        if (drawer && drawer.hasAttribute('open') && typeof drawer.hide === 'function') {
          drawer.hide();
        }

        openPanel();
      });
    });
  }

  function refreshUI() {
    var state = getState();
    var count = ACHIEVEMENTS.filter(function (a) { return !!state[a.id]; }).length;
    var pct = Math.round((count / ACHIEVEMENTS.length) * 100);

    var badge = document.getElementById('vq-badge');
    if (badge) badge.textContent = count;

    var fill = document.getElementById('vq-fill');
    if (fill) fill.style.width = pct + '%';

    var listHtml = ACHIEVEMENTS.map(function (a) {
      var done = !!state[a.id];
      return '<li class="vq-item' + (done ? ' vq-item--done' : '') + '">' +
        '<span class="vq-item__icon">' + a.icon + '</span>' +
        '<span class="vq-item__text">' +
          '<span class="vq-item__name">' + a.name + '</span>' +
          '<span class="vq-item__desc">' + a.desc + '</span>' +
        '</span>' +
        (done ? '<span class="vq-item__check" aria-label="Complete">✓</span>' : '') +
      '</li>';
    }).join('');

    var list = document.getElementById('vq-list');
    if (list) list.innerHTML = listHtml;

    // Section widget (optional — rendered when villain-progress section is on page)
    var sectionList = document.getElementById('vq-section-list');
    if (sectionList) sectionList.innerHTML = listHtml;

    var sectionFill = document.getElementById('vq-section-fill');
    if (sectionFill) sectionFill.style.width = pct + '%';

    var sectionCount = document.getElementById('vq-section-count');
    if (sectionCount) sectionCount.textContent = count + ' / ' + ACHIEVEMENTS.length;
  }

  // ── Achievement 1: Explorer ───────────────────────────────────────────────
  function checkExplorer() {
    if (isUnlocked('explorer')) return;
    var ctx = window.vqContext || {};
    // Matches common about/story page handles; also checks pageType from context
    if (ctx.pageType === 'page' && /^(about|about-us|our-story|story|brand|villains|who-we-are)$/.test(ctx.pageHandle || '')) {
      unlock('explorer');
    }
  }

  // ── Achievement 2: Window Shopper ─────────────────────────────────────────
  function trackWindowShopper() {
    if (isUnlocked('windowShopper')) return;
    var ctx = window.vqContext || {};
    if (!ctx.productHandle) return;

    var viewed;
    try {
      viewed = new Set(JSON.parse(localStorage.getItem(LS.products) || '[]'));
    } catch (e) { viewed = new Set(); }

    viewed.add(ctx.productHandle);
    try { localStorage.setItem(LS.products, JSON.stringify(Array.from(viewed))); } catch (e) {}

    if (viewed.size >= 5) unlock('windowShopper');
  }

  // ── Achievement 3: Hanging Out ────────────────────────────────────────────
  function initHangingOut() {
    if (isUnlocked('hangingOut')) return;
    var GOAL = 300;

    function savedTime() {
      return parseInt(localStorage.getItem(LS.time) || '0', 10);
    }
    function saveTime(t) {
      try { localStorage.setItem(LS.time, String(t)); } catch (e) {}
    }

    var seconds = savedTime();
    if (seconds >= GOAL) { unlock('hangingOut'); return; }

    var interval = setInterval(function () {
      if (document.visibilityState !== 'visible') return;
      seconds++;
      if (seconds % 30 === 0) saveTime(seconds);
      if (seconds >= GOAL) {
        saveTime(GOAL);
        clearInterval(interval);
        unlock('hangingOut');
      }
    }, 1000);

    window.addEventListener('beforeunload', function () { saveTime(seconds); });
  }

  // ── Achievement 4: First Pick ─────────────────────────────────────────────
  function initFirstPick() {
    if (isUnlocked('firstPick')) return;

    var _fetch = window.fetch;
    window.fetch = function () {
      var url = typeof arguments[0] === 'string' ? arguments[0]
        : (arguments[0] && arguments[0].url) || '';
      if (url.includes('/cart/add')) unlock('firstPick');
      return _fetch.apply(this, arguments);
    };

    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (typeof url === 'string' && url.includes('/cart/add')) {
        this.addEventListener('load', function () { unlock('firstPick'); }, { once: true });
      }
      return _open.apply(this, arguments);
    };
  }

  // ── Achievement 5: Style Curator ──────────────────────────────────────────
  function cacheProductCollections() {
    var ctx = window.vqContext || {};
    if (!ctx.productHandle || !ctx.productCollections) return;
    try {
      var cache = JSON.parse(localStorage.getItem(LS.collections) || '{}');
      cache[ctx.productHandle] = ctx.productCollections;
      localStorage.setItem(LS.collections, JSON.stringify(cache));
    } catch (e) {}
  }

  function checkStyleCurator() {
    if (isUnlocked('styleCurator')) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cache;
        try { cache = JSON.parse(localStorage.getItem(LS.collections) || '{}'); } catch (e) { cache = {}; }
        var allCollections = new Set();
        cart.items.forEach(function (item) {
          (cache[item.handle] || []).forEach(function (c) { allCollections.add(c); });
        });
        if (allCollections.size >= 2) unlock('styleCurator');
      })
      .catch(function () {});
  }

  function initStyleCurator() {
    cacheProductCollections();
    if (isUnlocked('styleCurator')) return;
    document.addEventListener('cart:updated', checkStyleCurator);
  }

  // ── Boot ──────────────────────────────────────────────────────────────────
  // Preload canvas-confetti so it's ready when an achievement fires
  (function () {
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js';
    s.async = true;
    document.head.appendChild(s);
  })();

  document.addEventListener('DOMContentLoaded', function () {
    buildWidget();
    initAchievementsNavLink();
    initHangingOut();
    initFirstPick();
    initStyleCurator();
    checkStyleCurator();
    // Delay page-view achievements so they fire after the visitor has settled
    setTimeout(function () {
      checkExplorer();
      trackWindowShopper();
    }, 1500);
  });
})();
